var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showPilotTooltip
    ? _c(
        "div",
        {
          staticClass: "pilot-tooltip",
          style: {
            left: `${_vm.pilotTooltipOffset.x}px`,
            top: `${_vm.pilotTooltipOffset.y}px`,
          },
        },
        [
          _c("div", { staticClass: "pilot-tooltip__title" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("pilotTooltipTitle")) + "\n  "),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "pilot-tooltip__confirm-btn",
              on: { click: _vm.onConfirm },
            },
            [
              _c("div", [_vm._v(_vm._s(_vm.$t("pilotTooltipConfirm")))]),
              _vm._v(" "),
              _vm._m(0),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "pilot-tooltip__cancel-btn",
              on: { click: _vm.onCancel },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("pilotTooltipCancel")) + "\n  ")]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ripple-loader" }, [
      _c("div", { staticClass: "ripple-loader__ripple1" }),
      _vm._v(" "),
      _c("div", { staticClass: "ripple-loader__ripple2" }),
      _vm._v(" "),
      _c("div", { staticClass: "ripple-loader__ripple3" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }